import { render, staticRenderFns } from "./AIChatMessage.vue?vue&type=template&id=149cb5e8&scoped=true"
import script from "./AIChatMessage.vue?vue&type=script&lang=js"
export * from "./AIChatMessage.vue?vue&type=script&lang=js"
import style0 from "./AIChatMessage.vue?vue&type=style&index=0&id=149cb5e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149cb5e8",
  null
  
)

export default component.exports